import { useCombobox, useMultipleSelection, } from 'downshift';
import { sharedOnSelectedItemChange, sharedOnStateChange } from './shared';
import { useSelectStateReducers } from './useSelectStateReducers';
export const useComboboxHook = (args) => {
    const { initialSelectedItem, isDisabled, isMultiSelect = false, listItems, onChange, onInputChange, onInternalStateChange, renderItemToString, stateReducer, } = args;
    const useComboboxArgs = () => {
        if (isMultiSelect) {
            return {
                selectedItem: null,
            };
        }
        else {
            return {
                initialSelectedItem,
            };
        }
    };
    const { closeMenu, getInputProps, getItemProps, getLabelProps, getMenuProps, getToggleButtonProps, highlightedIndex, inputValue, isOpen, openMenu, selectedItem, selectItem, } = useCombobox({
        ...useComboboxArgs(),
        items: listItems,
        itemToString: renderItemToString,
        onSelectedItemChange: (changes) => sharedOnSelectedItemChange(changes, isDisabled, onChange),
        onStateChange: (state) => sharedOnStateChange(state, onInternalStateChange, onInputChange),
        stateReducer,
    });
    return {
        useComboboxControlProps: {
            closeMenu,
            getInputProps,
            getItemProps,
            getLabelProps,
            getMenuProps,
            getToggleButtonProps,
            highlightedIndex,
            inputValue,
            isOpen,
            openMenu,
            selectedItem,
            selectItem,
        },
    };
};
export const useSingleSelectHooks = (args) => {
    const { initialSelectedItem, isDisabled, itemIsDisabled, listItems, onChange, onInputChange, onInternalStateChange, renderItemToString, selectInput, updateFilteredItems, } = args;
    // Custom hook for the SingleSelect state reducer
    const { comboboxStateReducer } = useSelectStateReducers({
        callCloseMenu: () => closeMenu(),
        callOpenMenu: () => openMenu(),
        itemIsDisabled,
        renderItemToString,
        selectInput,
        updateFilteredItems,
    });
    const { useComboboxControlProps } = useComboboxHook({
        initialSelectedItem,
        isDisabled,
        listItems,
        onChange,
        onInputChange,
        onInternalStateChange,
        renderItemToString,
        stateReducer: comboboxStateReducer,
    });
    const { closeMenu, openMenu } = useComboboxControlProps;
    return {
        useComboboxControlProps,
    };
};
export const useMultiSelectHooks = (args) => {
    const { initialSelectedItems = [], isDisabled, itemIsDisabled, listItems, onChange, onInputChange, onInternalStateChange, renderItemToString, selectInput, updateFilteredItems, safelyCallItemToID, } = args;
    // Custom hook for the MultiSelect state reducers
    const { comboboxStateReducer, multipleSelectionStateReducer } = useSelectStateReducers({
        callAddSelectedItem: (item) => {
            const itemIndex = selectedItems?.findIndex((selectedItem) => safelyCallItemToID(selectedItem) === safelyCallItemToID(item));
            if (itemIndex !== -1) {
                removeSelectedItem(selectedItems[itemIndex]);
            }
            else {
                addSelectedItem(item);
            }
        },
        callOpenMenu: () => openMenu(),
        callSelectItem: (item) => selectItem(item),
        isMultiSelect: true,
        itemIsDisabled,
        renderItemToString,
        selectInput,
        updateFilteredItems,
    });
    const { getSelectedItemProps, getDropdownProps, addSelectedItem, removeSelectedItem, selectedItems, setSelectedItems, } = useMultipleSelection({
        initialSelectedItems,
        onSelectedItemsChange: (changes) => sharedOnSelectedItemChange(changes, isDisabled, onChange),
        stateReducer: multipleSelectionStateReducer,
    });
    const { useComboboxControlProps } = useComboboxHook({
        isDisabled,
        isMultiSelect: true,
        listItems,
        onChange,
        onInputChange,
        onInternalStateChange,
        renderItemToString,
        stateReducer: comboboxStateReducer,
    });
    const { openMenu, selectItem } = useComboboxControlProps;
    return {
        useComboboxControlProps,
        useMultipleSelectionControlProps: {
            addSelectedItem,
            getDropdownProps,
            getSelectedItemProps,
            removeSelectedItem,
            selectedItems,
            setSelectedItems,
        },
    };
};
